import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSettings } from 'contexts/SettingsContextUtils';
import { Maybe, Scalars } from 'services/graphqltypes';

type MultilingualTextProps = {
  value?: Maybe<Scalars['JSON'] | string> | null | undefined;
};

// react-intl's FormattedMessage doesn't support fetching translations from an API, but it does support being fed the translation value through its 'values' parameter.
// translationId must be present in lang/locales/_locale_.js

// When constructing the translationObject, we take care of falling back to defaultLocale in case a translation for user's current language is not present
// Format of data in database: { "defaultLocale": "_language_code_", "it": "buongiorno", "en": "good morning", "fr": "bonjour" }

const MultilingualText = ({ value }: MultilingualTextProps): React.ReactElement => {
  const { locale: currentLang } = useSettings();
  const translationId = 'dynamicTranslationFromApi';
  let resolvedValue = value;

  if (typeof resolvedValue === 'string') {
    try {
      const parsedValue = JSON.parse(resolvedValue);
      if (parsedValue && typeof parsedValue === 'object' && typeof parsedValue.defaultLocale === 'string') {
        resolvedValue = parsedValue;
      } else {
        return <>{resolvedValue}</>;
      }
    } catch {
      return <>{resolvedValue}</>;
    }
  }

  const translations = resolvedValue && typeof resolvedValue === 'object' ? resolvedValue : {};
  const currentTranslation = translations[currentLang];
  const defaultTranslation = typeof translations.defaultLocale === 'string'
    ? translations[translations.defaultLocale]
    : undefined;
  const translationObject = {
    [translationId]: typeof currentTranslation === 'string' && currentTranslation
      ? currentTranslation
      : typeof defaultTranslation === 'string' ? defaultTranslation : '',
  };
  return <FormattedMessage id={translationId} values={translationObject} />;
};

export default MultilingualText;
